import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LazyLoadEvent, TabPanel, SelectItem } from 'primeng';
import { IInboxJob } from '../../interfaces/inbox-job';
import { InboxBackService } from '../../services';
import { InboxJobsService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { CustomerJobsGridComponent } from './customer-jobs-grid.component';
import { VmeJobsTasksComponent } from './vme-jobs-tasks.component';

@Component({
  selector: 'customer-jobs-inbox',
  templateUrl: './customer-jobs-inbox.component.html',
  styleUrls: ['./jobs-inbox.scss'],
})
export class CustomerJobsInboxComponent implements OnInit {
  public inboxType_Unallocated = 1;
  public inboxType_Waiting = 2;
  public inboxType_Completed = 3;
  public inboxType_Closed = 5;
  public inboxType_Cancelled = 6;
  public inboxType_Live = 4; //special type to determine selected tab.
  public inboxType_GlobalFilter = 7;

  public liveTasks_InboxType_Customer = 3;

  @ViewChildren('jobgrid')
  jobGrids: QueryList<CustomerJobsGridComponent>;

  @ViewChild('jobtasks')
  jobTasks: VmeJobsTasksComponent;

  @ViewChild('tabUnallocated')
  tabUnallocated: TabPanel;
  @ViewChild('tabWaiting')
  tabWaiting: TabPanel;
  @ViewChild('tabCompleted')
  tabCompleted: TabPanel;
  @ViewChild('tabCancelled')
  tabCancelled: TabPanel;
  @ViewChild('tabClosed')
  tabClosed: TabPanel;
  @ViewChild('tabLive')
  tabLive: TabPanel;
  @ViewChild('tabGlobalFilter')
  tabGlobalFilter: TabPanel;

  public isLoaded: boolean = false;
  public jobIsSelected: boolean = false;
  public selecteditem: any;
  public selectedTab = 0;

  constructor(
    private route: ActivatedRoute,
    private inboxjobsService: InboxJobsService,
    private inboxBackService: InboxBackService,
    private vmeInboxjobsService: VmeInboxJobsService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.selectedTab = params['selectedTab'] || 0;
      if (!this.selectedTab) {
        var prevTab = this.inboxBackService.getTab();
        this.selectedTab = prevTab;
      }
    });
  }

  jobSelectionChanged(obj: IInboxJob) {
    var item = obj[0];
    var inboxType = obj[1];

    if (this.getTabByInboxType(inboxType).selected) {
      this.jobIsSelected = item != null;
      this.selecteditem = null;

      if (item != null) {
        this.inboxjobsService.getJob(item.id, item.orderId).then((res) => {
          this.selecteditem = { job: res };
        });
      }
    }
  }

  onTaskChanged(item: any) {
    this.jobIsSelected = item != null;
    this.selecteditem = null;

    if (item != null) {
      this.inboxjobsService.getJob(item.jobId, item.orderId).then((res) => {
        this.selecteditem = { job: res, taskId: item.id };
      });
    }
  }

  getTabByInboxType(inboxType) {
    switch (inboxType) {
      case this.inboxType_Waiting:
        return this.tabWaiting;
      case this.inboxType_Unallocated:
        return this.tabUnallocated;
      case this.inboxType_Completed:
        return this.tabCompleted;
      case this.inboxType_Cancelled:
        return this.tabCancelled;
      case this.inboxType_Closed:
        return this.tabClosed;
      case this.inboxType_GlobalFilter:
        return this.tabGlobalFilter;
    }
  }

  getInboxTypeBySelectedTab() {
    if (this.tabWaiting && this.tabWaiting.selected) return this.inboxType_Waiting;
    if (this.tabUnallocated && this.tabUnallocated.selected) return this.inboxType_Unallocated;
    if (this.tabCompleted && this.tabCompleted.selected) return this.inboxType_Completed;
    if (this.tabCancelled && this.tabCancelled.selected) return this.inboxType_Cancelled;
    if (this.tabClosed && this.tabClosed.selected) return this.inboxType_Closed;
    if (this.tabLive && this.tabLive.selected) return this.inboxType_Live;
    if (this.tabGlobalFilter && this.tabGlobalFilter.selected) return this.inboxType_GlobalFilter;
  }

  onGridAction(event) {
    this.jobGrids.forEach((o) => {
      if (o) o.gridUpdate();
    });
    if (this.jobTasks) this.jobTasks.gridUpdate();
  }

  isTask(item: any) {
    return 'tasks' in item;
  }

  onTabChange(event) {
    this.selectedTab = event.index;
    this.inboxBackService.setTab(this.getInboxTypeBySelectedTab());

    this.jobIsSelected = false;

    //deselect grid items on all tabs
    this.jobGrids.forEach((o) => {
      if (o) o.deselectJobFromInbox();
    });
    if (this.jobTasks) this.jobTasks.deselectTask();
  }
}
